/**
 * Interactive Graphics
 */

import SelectorEngine from '../../../../shared/js/dom/selector-engine';
import Manipulator    from '../../../../shared/js/dom/manipulator';
import EventHandler   from '../../../../shared/js/dom/event-handler';

// -------
// Private
// -------

const NAME = 'interactive-graphic';

const initInformations = (element) => {
	const hotspots = SelectorEngine.find('.interactive-graphic__hotspot', element);

	for (const hotspot of hotspots) {
		EventHandler.on(hotspot, 'click', (event) => {
			event.preventDefault();
			toggleInformation(element, hotspot);
		});
	}

	positionTooltips(element);
};

const toggleInformation = (element, hotspot) => {
	const area = Manipulator.getDataAttribute(hotspot, 'area');
	if (!area) return;

	const informations = SelectorEngine.find('.info', element);
	const target = SelectorEngine.findOne(`.info[data-area="${area}"]`, element);

	if (!target) return;

	const wasActive = target.classList.contains('is-active');

	for (const info of informations) {
		Manipulator.removeClass(info, 'is-active');
	}

	if (!wasActive) {
		Manipulator.addClass(target, 'is-active');
	}
};

const positionTooltips = (element) => {
	// nur Desktop
	if (window.matchMedia('(max-width: 767px)').matches) return;

	const tooltipContainer = SelectorEngine.findOne('.interactive-graphic__tooltips', element);
	const hotspots = SelectorEngine.find('.interactive-graphic__hotspot', element);

	if (!tooltipContainer) return;

	const containerRect = tooltipContainer.getBoundingClientRect();

	for (const hotspot of hotspots) {

		const area = Manipulator.getDataAttribute(hotspot, 'area');
		if (!area) continue;

		const tooltip = SelectorEngine.findOne(`.info[data-area="${area}"]`, element);
		const point = SelectorEngine.findOne('.interactive-graphic__point', hotspot);

		if (!tooltip || !point) continue;

		const pointRect = point.getBoundingClientRect();

		const x = pointRect.left - containerRect.left + pointRect.width / 2;
		const y = pointRect.top - containerRect.top + pointRect.height / 2;

		tooltip.style.left = `${x}px`;
		tooltip.style.top = `${y}px`;
	}
};

const closeInformations = (element) => {

	const infos = SelectorEngine.find('.info', element);

	for (const info of infos) {
		Manipulator.removeClass(info, 'is-active');
	}

};

// -------
// Public
// -------

const init = () => {
	const COLLECTION = SelectorEngine.find(`[data-ce="${NAME}"]`);

	if(!COLLECTION.length) return;

	for(const element of COLLECTION) {
		initInformations(element)
	}

	EventHandler.on(window, 'load', () => {
		for(const element of COLLECTION) {
			positionTooltips(element);
		}
	});

	// bei Resize Tooltip Positionen neu berechnen
	EventHandler.on(window, 'resize', () => {
		for(const element of COLLECTION) {
			positionTooltips(element);
		}
	});

	EventHandler.on(document, 'click', (event) => {
		for (const element of COLLECTION) {
			const clickedHotspot = event.target.closest('.interactive-graphic__hotspot');
			const clickedTooltip = event.target.closest('.info');

			if (clickedHotspot || clickedTooltip) {
				continue;
			}

			closeInformations(element);
		}

	});
};

// Export
export default {
	init: init
};
